import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import Filter from './Components/Filter'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import { ServerSideTable } from 'Presentation/Components/Table'
import { KTSVG } from '_metronic/helpers'

import useViewModel from './ViewModel'
import { IssueType } from 'Configuration/Paco'
import { Fragment } from 'react'

const RequestListDesktopView: React.FC = () => {
  const {
    isHideWritingAction,
    filter,
    onChangeFilter,
    submitFilter,
    clearFilter,
    createRequest,
    TABLE_CONFIGS,
    data,
    totalData,
    nextPageDesktop,
  } = useViewModel()

  return (
    <ViewPageTitle>
      <Filter
        filter={filter}
        onChangeFilter={onChangeFilter}
        onSubmit={submitFilter}
        onClearFilter={clearFilter}
      />

      <div className='row gy-5 mb-5'>
        <div className='col-12'>
          <PageBreadCrumb />
        </div>

        <div className='col-12'>
          <div className='card'>
            {/* begin:: Header */}
            <div className='card-header'>
              <div className='card-title w-25'>
                {!isHideWritingAction && (
                  <Fragment>
                    <button
                      onClick={() => createRequest(IssueType.RequestSteelPlates)}
                      className='btn btn-sm btn-light-success fw-bold'
                      style={{ whiteSpace: 'nowrap' }}>
                      <KTSVG
                        path='/media/icons/duotune/general/gen041.svg'
                        svgClassName='svg-icon-1'
                      />
                      ขอแผ่นเหล็ก
                    </button>

                    <button
                      onClick={() => createRequest(IssueType.RequestChangePileSize)}
                      className='btn btn-sm btn-light-success ms-4 fw-bold'
                      style={{ whiteSpace: 'nowrap' }}>
                      <KTSVG
                        path='/media/icons/duotune/general/gen041.svg'
                        svgClassName='svg-icon-1'
                      />
                      เปลี่ยนแปลงขนาดเสา
                    </button>

                    <button
                      onClick={() => createRequest(IssueType.RequestChangeShipping)}
                      className='btn btn-sm btn-light-success ms-4 fw-bold'
                      style={{ whiteSpace: 'nowrap' }}>
                      <KTSVG
                        path='/media/icons/duotune/general/gen041.svg'
                        svgClassName='svg-icon-1'
                      />
                      เพิ่มจำนวน (ขนส่ง)
                    </button>
                  </Fragment>
                )}
              </div>
              <div className='card-toolbar'>
                <button
                  className='btn btn-sm btn-light-primary ms-4 fw-bold'
                  id='kt_request_filter_toggle'
                  style={{ whiteSpace: 'nowrap' }}>
                  <KTSVG path='/media/icons/duotune/general/gen004.svg' svgClassName='svg-icon-1' />
                  ค้นหา
                </button>
              </div>
            </div>
            {/* end:: Header */}

            {/* begin:: Body */}
            <div className='card-body horizontal-paddingless'>
              <ServerSideTable
                pagination
                isGrey
                page={filter.page}
                data={data}
                columns={TABLE_CONFIGS}
                items_per_page={filter.pageSize}
                totalData={totalData}
                updatePage={page => {
                  if (page) {
                    nextPageDesktop(page)
                  }
                }}
              />
            </div>
            {/* end:: Body */}
          </div>
        </div>
        {/* end:: Table */}
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: true,
            isSeparator: false,
            path: '#',
            title: 'รายการทั้งหมด',
            icon: '/media/icons/duotune/files/fil005.svg',
          },
        ]}>
        คำร้องขอ
      </PageTitle>

      {children}
    </>
  )
}

export default RequestListDesktopView
